var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"no-toppad",attrs:{"row":"","wrap":"","no-gutters":"","text-xs-right":""}},[_c('v-container',[_c('v-row',{attrs:{"noGutters":""}},[_c('v-col',{attrs:{"cols":"12","md":"12","sm":"12"}},[_c('div',{staticClass:"sections-container"},[_c('AccountInfo'),_c('PasswordChange')],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }